import SurveyJSGlobalStateSetupHandler from "./SurveyJSGlobalStateSetupHandler";

export default class SurveyJSGlobalStateSetupHandlerFactory {
    private static readonly INSTANCE = new SurveyJSGlobalStateSetupHandler();
    public static getInstance() {
        return this.INSTANCE;
    }
}